module.exports = __webpack_public_path__ + "img/vue1-corpsavant_rose.b6706134.png";